module.exports = __webpack_public_path__ + "static/media/How_to_play.81c3c747.png";